export class FileManager {
  static resetAll() {}
  static get(..._args: any[]): any {
    return undefined;
  }
}
